import { useEffect, useState } from "react";
import { Form, Col, Row, Button } from "antd";
import usePost from "../../../global/hooks/usePost";
import { useParams } from "react-router-dom";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import { CloseOutlined } from "@ant-design/icons";
import { RiQrCodeFill } from "react-icons/ri";
import CustomTextArea from "../../../global/components/inputWidgets/CustomTextArea";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { DuplicatePlateModal } from "./DuplicatePlateModal";

const PLATE_PRODUCTION_BASE = `${process.env.REACT_APP_API_URL}/api/plates`;

export const PlateProductionAddbyList = ({
  isModalForm,
  onCancel,
  platesRefetch,
}) => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const [modal, setModal] = useState(null);

  const postUrl = `${PLATE_PRODUCTION_BASE}/bulk-create-by-list/`;

  const {
    data: postData,
    loading: postLoading,
    error: postError,
    postData: postAction,
  } = usePost(postUrl);

  const onFinish = async (values) => {
    const modValues = {
      ProductionNo: Number(id),
      CodeList: values.CodeList,
    };
    try {
      await postAction(modValues);
    } catch (error) {
      openErrorNotification("Something went wrong.");
      console.log(error);
    }
  };

  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong",
      );
    } else if (!postLoading && !postError && postData) {
      const details = postData?.data?.details || [];
      const hasDuplicates = details.some((item) => item?.status === 400);
      if (hasDuplicates) {
        setModal(details);
        platesRefetch?.();
      } else {
        openConfirmNotification("Success");
        platesRefetch?.();
        if (isModalForm) {
          onCancel?.();
        }
      }
    }
  }, [postError, postData, postLoading]);

  return (
    <>
      <Form
        validateTrigger={"onChange"}
        form={form}
        onFinish={onFinish}
        scrollToFirstError
        layout={"vertical"}
        autoComplete={"off"}
      >
        <div
          className={`${isModalForm ? "" : "bg-white overflow-hidden border rounded-[4px]"
            }`}
        >
          {!isModalForm && (
            <div className="flex items-center bg-gray-200 p-2.5">
              <RiQrCodeFill className="text-[18px] text-black " />
              <span className="text-[.935rem] text-black font-['Poppins'] ml-2 ">
                Plate
              </span>
            </div>
          )}
          <div className="px-2 pt-1 pb-3">
            <Row gutter={[16, 8]}>
              <Col
                xs={24}
                sm={24}
                md={isModalForm ? 24 : 12}
                lg={isModalForm ? 24 : 12}
                xl={isModalForm ? 24 : 12}
              >
                <CustomTextArea
                  label="Code List"
                  name="CodeList"
                  placeholder="Code List"
                  rows={4}
                  rules={[
                    {
                      required: true,
                      message: "Code List is required",
                    },
                    // {
                    //   validator: async (_, value) => {
                    //     if (!value) return Promise.resolve();

                    //     const codes = value
                    //       .split("\n")
                    //       .map((v) => v.trim())
                    //       .filter((v) => v);

                    //     for (const code of codes) {
                    //       if (!/^\d+$/.test(code)) {
                    //         return Promise.reject(
                    //           new Error(`Invalid code: ${code}`),
                    //         );
                    //       }
                    //     }

                    //     return Promise.resolve();
                    //   },
                    // },
                  ]}
                  required
                />
              </Col>
            </Row>
          </div>
        </div>
      </Form>
      {isModalForm && (
        <div className="flex justify-center space-x-2 mt-2.5">
          <Button
            type="primary"
            className="mr-2 min-w-[104px] h-[30px] py-1 px-[10px] font-medium flex items-center "
            onClick={() => form.submit()}
            loading={postLoading}
            disabled={postLoading}
          >
            <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
            <span>Apply</span>
          </Button>
          <Button className="reset-button" onClick={onCancel}>
            <CloseOutlined />
            <span>Cancel</span>
          </Button>
        </div>
      )}

      <DuplicatePlateModal
        isModalOpen={modal !== null}
        setModal={setModal}
        modal={modal}
        isModalForm={isModalForm}
      />
    </>
  );
};